import React, { useContext } from 'react';
export const defaultConfig = {
    isIconGroup: false,
};
export const IconGroupContext = React.createContext(defaultConfig);
export const useIconGroup = () => useContext(IconGroupContext);
